import React from "react";
import PropTypes from "prop-types";

// components:
import Tooltip from "core/Tooltip";
import Button from "core/Button";
import SrOnly from "core/SrOnly";

// icons:
import Add from "core/ReusableIcons/Add";
import Lock from "core/ReusableIcons/Lock";

// styles:
import colors from "core/colors";
import { LockButton } from "./styles";

const FooterContent = ({ isFreeUser, handleFooterButtonClick }) => {
    const price = (window._nounConfig.yearlyProPlanCents / 100).toFixed(2);
    const unlockTooltipText = (
        <>
            <a href="#">Unlock</a> unlimited kits for ${price}
        </>
    );

    return (
        <>
            <Button
                styleType="outline"
                width="100%"
                justifyContent="flex-start"
                iconPosition="left"
                onClick={handleFooterButtonClick}
                isDisabled={isFreeUser}
            >
                <Add fillColor={isFreeUser && colors.storm} />
                Add to a New Kit
            </Button>

            {isFreeUser && (
                <Tooltip message={unlockTooltipText}>
                    <LockButton>
                        <Lock fillColor={isFreeUser && colors.storm} />
                        <SrOnly>{unlockTooltipText}</SrOnly>
                    </LockButton>
                </Tooltip>
            )}
        </>
    );
};

FooterContent.propTypes = {
    isFreeUser: PropTypes.bool.isRequired,
    handleFooterButtonClick: PropTypes.func.isRequired
};

export default FooterContent;
